import { stagger, timeline, type TimelineDefinition } from "motion";

document.addEventListener("DOMContentLoaded", () => {
  const menuOverlay = document.getElementById("menu-overlay");
  const menuToggle = document.getElementById("menu-toggle");
  const menu = document.getElementById("site-nav");

  menuToggle?.addEventListener("click", () => {
    menuToggle?.classList.toggle("is-active");
    menuOverlay?.classList.toggle("pointer-events-none");
    document.body.classList.toggle("overflow-hidden");

    const enterSequence: TimelineDefinition = [
      ["#menu-overlay", { opacity: 1 }, { duration: 0.5 }],
      [
        ".site-nav-item",
        { y: ["300%", 0], opacity: [1] },
        {
          delay: stagger(0.1),
          duration: 0.4,
          easing: [0.22, 0.03, 0.26, 1],
          at: 0.2,
        },
      ],
    ];

    const exitSequence: TimelineDefinition = [
      [
        ".site-nav-item",
        { y: "-200%", opacity: 0 },
        {
          delay: stagger(0.1),
          duration: 0.3,
          easing: [0.22, 0.03, 0.26, 1],
        },
      ],
      ["#menu-overlay", { opacity: 0 }, { duration: 0.5, at: 0.3 }],
    ];

    let sequence = menu?.classList.contains("is-open")
      ? exitSequence
      : enterSequence;
    menu?.classList.toggle("is-open");

    timeline(sequence);
  });
});
